import { createFileRoute, useParams } from '@tanstack/react-router';

import {
  AttributeRenderer,
  SectionFormWrapper,
  type RenderContentProps,
  useGetPersonHandlingCertificationDetail,
  useUpdatePersonHandlingCertificationDetail,
} from '../../../../-shared';

export const Route = createFileRoute(
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/',
)({
  component: PersonHandlingCertificationDetail,
});

function PersonHandlingCertificationDetail() {
  const { id, personCertificationInformationId } = useParams({
    from: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/',
  });

  return (
    <SectionFormWrapper
      useGetDetailQuery={useGetPersonHandlingCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      useSaveMutation={useUpdatePersonHandlingCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      renderContent={({ section }: RenderContentProps) => (
        <AttributeRenderer
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
        />
      )}
    />
  );
}
